import Vue from 'vue';

Vue.filter('upper', (v: any) => v ? v.toString().toUpperCase() : '');
